// file: /src/boot/register-my-component.js
import { boot } from 'quasar/wrappers';

import MyButton from '../components/basic/MyButton.vue'
import MyKachel from '../components/basic/MyKachelComponent.vue'
import Fragezeichen from '../components/basic/FragezeichenComponent.vue'
import MyDateComponent from '../components/basic/MyDateComponent.vue'
import MyDatetimeComponent from '../components/basic/MyDatetimeComponent.vue'
import MyProduktList from '../components/basic/MyProduktListComponent.vue'
import PromoterSearch from '../components/basic/PromoterSearchComponent.vue'
import UserSearch from '../components/basic/UserSearchComponent.vue'
import PromotionMenu from '../components/PromotionMenuComponent.vue'
import MultiAuswahl from '../components/MultiAuswahlComponent.vue'
import MultiFilter from '../components/filters/MultiFilterComponent.vue'
import web from '../services/web'
import basedata from '../services/basedata'
import helpers from '../services/helpers'
import storage from '../services/storage'
import {createPinia} from 'pinia'

 import io from "socket.io-client";
//import { io } from 'socket.io-client';
// const socket =  io.connect("http://localhost:4000" ,{transports: ['websocket']})

import { Notify } from 'quasar'
import mitt from 'mitt';
import moment from 'moment';

import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'



import 'vue-json-viewer/style.css'
import JsonViewer from 'vue-json-viewer'


// Import JsonViewer as a Vue.js plugin



// import VueGoogleCharts from 'vue-google-charts'

// we globally register our component with Vue


// import ElementPlus from 'element-plus';
// import locale from 'element-plus/lib/locale/lang/de'
// import 'element-plus/lib/theme-chalk/index.css';
// import './element-variables.scss'
// import '@element-plus/icons'
//
// import lang  from 'element-plus/lib/locale/lang/de-de'
// locale(lang)


// import {watch} from 'vue'

export default boot(({ app }) => {



  app.component('Fragezeichen', Fragezeichen)
  app.component('UserSearch', UserSearch)
  app.component('PromoterSearch', PromoterSearch)
  app.component('MyButton', MyButton)
  app.component('MyKachel', MyKachel)
  app.component('MyDate', MyDateComponent)
  app.component('MyDatetime', MyDatetimeComponent)
  app.component('MyProduktList', MyProduktList)
  app.component('PromotionMenu', PromotionMenu)
  app.component('MultiAuswahl', MultiAuswahl);
  app.component('MultiFilter', MultiFilter);
  app.provide("web",web)

  const socket =  io("https://doit-activation.de" ,{transports: ['websocket']})
  socket.on("connect",()=> {
    console.log("Socket is Connected")
    const person=helpers.getUser() || helpers.getPromoter()
    if(person!=null){
      console.log("setMyId",person._id)
      socket.emit("setMyId",person._id)
      socket.emit("promoterPing",{person:person});
    }

    setInterval(() => {
      socket.emit("promoterPing",{person:person});
    },10000)
  })

  app.provide('socket', socket);
  
  
  
  app.provide('emitter', mitt());
  app.provide('basedata', basedata);
  app.provide('notify', Notify);
  app.provide('helpers', helpers);
  app.provide('moment', moment);
  app.provide('storage', storage);
  const user=storage.getUser()
  app.provide('user', user);



  // Use plugin with defaults

  async function reloadFragezeichen(){

    const  data = await web.get("/fragezeichen");

    app.provide('fragezeichen', data.fragezeichen);
  }

  reloadFragezeichen()
  // watch(() => user, (first, second) => {
  //   console.log(
  //     "Watch props.selected function called with args:",
  //     first,
  //     second
  //   );
  // },{deep:true});




  app.use(VueViewer)
  app.use(createPinia())

  app.use(JsonViewer)
  // app.use(ElementPlus)


  // app.use(VueGoogleCharts)

})
